import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=23831b5b&scoped=true"
import script from "./MobileView.vue?vue&type=script&lang=ts"
export * from "./MobileView.vue?vue&type=script&lang=ts"
import style0 from "./MobileView.vue?vue&type=style&index=0&id=23831b5b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23831b5b",
  null
  
)

export default component.exports